import React from "react";
import OnOffSettingsFields from "./OnOffSettingsFields";
import { Stack } from "@fluentui/react";
import FeatureSummary from "../../../../../Util/FeatureSummary";

const OnOffSettingsPage = ({ }) => {

   
    return (
            <>
            <Stack horizontal tokens={{ childrenGap: 30 }}>
                    <Stack
                        tokens={{ childrenGap: 20 }}
                        styles={{
                            root: {
                                width: 300,
                                paddingTop: 20,
                            },
                        }}
            >
                <OnOffSettingsFields />
                    </Stack>
            </Stack>
            <FeatureSummary
                label="About Site Notification On/Off Settings"
                summary="Control site notification visibility across your organization. Configure which clients, cobrands, or cobrand tags should see this notification bar. Use these settings to target specific user segments with important announcements."
            />
            </>
    );
};

export default OnOffSettingsPage;
